import Vue from 'vue';
import {
  SET_CONTACT,
  SET_CONTACT_COLUMNS,
  SET_MODAL_OPENED,
  SET_CONTENT_SEARCH,
  SET_MODAL_ACTION,
  CLEAR_CONTACT_HISTORY,
  SET_HISTORY_FOR_CONTACT,
  UPDATE_PARAMS_HISTORY_CONTACT,
  SET_MESSAGES_FROM_HISTORY,
  RESET_CONTACT,
  SET_CONTACTS_FOUND_JOB,
  SELECT_CONTACT_CONTACTS_FOUND,
  CLEAR_CONTACTS_FOUND,
  UPDATE_CONTACT_FOUND,
  SHOW_SUMMARY_DIALOG,
  SET_CONTACT_HISTORY,
  SET_FIELDS_CONTACT_CATEGORY,
  UPDATE_CONTACT,
  SET_LOADING_HISTORY,
  SET_CONTACT_FILTER,
  SET_CONTACT_FILTER_TYPE,
  SET_CONTACT_LATEST_CHURN_RISK,
  SET_CONTACT_TAGS,
} from '../../mutation-types';
import Contact from '../../../weon/models/Contact';

const mutations = {
  [SET_CONTACT](state, contact) {
    state.contact = contact;
  },
  [SET_CONTACT_LATEST_CHURN_RISK](state, churnRisk) {
    state.contactLatestChurnRisk = churnRisk;
  },

  [SET_CONTACT_TAGS](state, tags) {
    state.contactTags = tags;
  },

  [UPDATE_CONTACT](state, contact) {
    if (!state.contact) return;
    Vue.set(state.contact, 'data', [contact]);
  },

  [SET_CONTACT_COLUMNS](state, columns) {
    state.contactColumns = columns;
  },

  [SET_FIELDS_CONTACT_CATEGORY](state, categorys) {
    state.fieldsContactCategory = categorys;
  },

  [SET_MODAL_OPENED](state, opened) {
    state.modalOpened = opened;
  },

  [SET_CONTENT_SEARCH](state, content) {
    state.contentSearch = content;
  },

  [SET_MODAL_ACTION](state, action) {
    state.modalAction = action;
  },

  [CLEAR_CONTACT_HISTORY](state) {
    state.history = {};
    state.paramsHistory = {};
  },

  [SET_HISTORY_FOR_CONTACT](state, history) {
    Object.entries(history).forEach(([period, attendances]) => {
      const hasPeriodInHistory = state.history[period];

      if (hasPeriodInHistory)
        return (state.history[period] = [
          ...state.history[period],
          ...attendances,
        ]);

      state.history[period] = attendances;
    });
  },

  [UPDATE_PARAMS_HISTORY_CONTACT](state, queryParams) {
    state.paramsHistory = queryParams;
  },

  [SET_MESSAGES_FROM_HISTORY](state, { protocol, groupProtocol, messages }) {
    if (state.history[groupProtocol]) {
      const indexToMessages = state.history[groupProtocol].findIndex(
        (history) => history.protocol == protocol,
      );
      const history = state.history[groupProtocol][indexToMessages];
      history.messages = messages;
      state.history[groupProtocol].splice(indexToMessages, 1, history);
      // Object.assign(, { 'messages': messages })
    }
  },

  [RESET_CONTACT](state) {
    state.contact = new Contact();
    state.history = {};
    state.paramsHistory = {};
    state.contactsFound = {};
  },

  [SET_CONTACTS_FOUND_JOB](state, { protocol, contacts }) {
    const contactsProtocol = {};
    contactsProtocol[protocol] = contacts.map((contact) => ({
      ...contact,
      selected: false,
      lastContact: null,
    }));
    // TODO: Analisar o comportamento sem setá o contato cliente retido
    // state.contact = contactsProtocol[protocol][1]
    state.contactsFound = {
      ...state.contactsFound,
      ...contactsProtocol,
    };
  },

  [SELECT_CONTACT_CONTACTS_FOUND](state, { contactId, protocol }) {
    let contacts = state.contactsFound[protocol];

    if (!contacts) return;

    contacts = contacts.map((contact) => {
      if (contact.id == contactId) {
        contact.selected = true;
        return contact;
      }

      contact.selected = false;
      return contact;
    });

    state.contactsFound[protocol].splice(0, contacts.length, ...contacts);
  },

  [CLEAR_CONTACTS_FOUND](state, protocol) {
    delete state.contactsFound[protocol];
  },
  [UPDATE_CONTACT_FOUND](state, jobInfo) {
    const job = state.contactsFound.hasOwnProperty(jobInfo.protocol);
    if (job) {
      state.contactsFound[jobInfo.protocol].splice(0, 1, jobInfo.contactInfo);
    }
  },
  [SHOW_SUMMARY_DIALOG](state, show) {
    state.summaryDialog = show;
  },
  [SET_LOADING_HISTORY](state, value) {
    state.loadingHistory = value;
  },
  [SET_CONTACT_HISTORY](state, payload) {
    if (!payload) {
      state.historyFromContact = null;
      state.originalHistoryFromContact = null;
      return;
    }

    const {
      history,
      updateOriginalHistory,
      params: { page },
    } = payload || {};

    const historyPagination = () => {
      const { data: dataHistory } = state.historyFromContact;

      let _assignHistory = {};

      Object.entries(history.data).forEach(([date, values]) => {
        if (dataHistory[date]) {
          const _values = [];
          _values.push(...values);
          _values.push(...dataHistory[date]);
          _assignHistory[date] = _values;
        } else {
          _assignHistory[date] = values;
        }
      });

      console.log('dataHistory', dataHistory);

      const assignHistory = { ...dataHistory, ..._assignHistory };

      Vue.set(state.historyFromContact, 'data', assignHistory);
      Vue.set(state.historyFromContact, 'current_page', page);
    };

    if (page && page > 1) {
      historyPagination();
      return;
    }
    if (
      updateOriginalHistory ||
      (!state.historyFromContact && !state.originalHistoryFromContact) ||
      (state.historyFromContact && !state.originalHistoryFromContact)
    ) {
      state.originalHistoryFromContact = history;
    }

    state.historyFromContact = history;
  },
  [SET_CONTACT_FILTER](state, contactFilterId) {
    state.contactFilterSelected = contactFilterId;
  },
  [SET_CONTACT_FILTER_TYPE](state, type) {
    state.contactFilterType = type;
  },
};

export default mutations;
